import { schema } from 'normalizr';

export const productDataReviewSchema = new schema.Entity('productDataReviews', {}, { idAttribute: 'ProductDataReviewId' });
export const productDataReviewListSchema = [productDataReviewSchema];
